import React, { useState } from 'react';
import '../styles/ForgotPassword.css';
import '../styles/AuthForm.css'; // Für Sprachumschaltung Styles
import passwordResetApi from '../services/passwordResetApi';
import { useLanguage } from '../contexts/LanguageContext';

const ForgotPassword = ({ onBack, onShowLogin }) => {
    const { t, language, switchLanguage } = useLanguage();
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [errors, setErrors] = useState({});

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setMessage('');

        // Validation
        const newErrors = {};
        if (!email.trim()) {
            newErrors.email = t('emailRequired');
        } else if (!validateEmail(email)) {
            newErrors.email = t('invalidEmail');
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setIsLoading(true);

        try {
            const response = await passwordResetApi.forgotPassword(email);
            setIsSuccess(true);
            // Verwende immer die aktuell geladene Übersetzung
            setMessage(t('emailSentMessage'));
        } catch (error) {
            setIsSuccess(false);
            setMessage(error.message || t('passwordResetError'));
        } finally {
            setIsLoading(false);
        }
    };

    if (isSuccess) {
        return (
            <div className="forgot-password-container">
                <div className="forgot-password-card">
                    {/* Language Switcher auch im Erfolgs-Screen */}
                    <div className="auth-language-switcher">
                        <button
                            className={`auth-language-btn ${language === 'en' ? 'active' : ''}`}
                            onClick={() => switchLanguage('en')}
                            title="English"
                            type="button"
                        >
                            🇺🇸
                        </button>
                        <button
                            className={`auth-language-btn ${language === 'de' ? 'active' : ''}`}
                            onClick={() => switchLanguage('de')}
                            title="Deutsch"
                            type="button"
                        >
                            🇩🇪
                        </button>
                    </div>
                    
                    <div className="forgot-password-header">
                        <h2>{t('emailSentTitle')}</h2>
                    </div>
                    <div className="forgot-password-content">
                        <div className="success-icon">✓</div>
                        <p className="success-message">{t('emailSentMessage')}</p>
                        <p className="info-text">
                            {t('checkEmailInstruction')}
                        </p>
                        <div className="forgot-password-actions">
                            <button 
                                type="button" 
                                className="back-to-login-btn"
                                onClick={onShowLogin}
                            >
                                {t('backToLogin')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-card">
                {/* Language Switcher */}
                <div className="auth-language-switcher">
                    <button
                        className={`auth-language-btn ${language === 'en' ? 'active' : ''}`}
                        onClick={() => switchLanguage('en')}
                        title="English"
                        type="button"
                    >
                        🇺🇸
                    </button>
                    <button
                        className={`auth-language-btn ${language === 'de' ? 'active' : ''}`}
                        onClick={() => switchLanguage('de')}
                        title="Deutsch"
                        type="button"
                    >
                        🇩🇪
                    </button>
                </div>
                
                <div className="forgot-password-header">
                    <h2>{t('forgotPasswordTitle')}</h2>
                    <p>{t('forgotPasswordDescription')}</p>
                </div>

                <form onSubmit={handleSubmit} className="forgot-password-form">
                    <div className="form-group">
                        <label htmlFor="email">{t('email')}</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={errors.email ? 'error' : ''}
                            placeholder={t('emailPlaceholder')}
                            disabled={isLoading}
                            autoFocus
                        />
                        {errors.email && <span className="error-text">{errors.email}</span>}
                    </div>

                    {message && (
                        <div className={`message ${isSuccess ? 'success' : 'error'}`}>
                            {message}
                        </div>
                    )}

                    <div className="forgot-password-actions">
                        <button 
                            type="submit" 
                            className="reset-btn"
                            disabled={isLoading}
                        >
                            {isLoading ? t('sendingResetLink') : t('sendResetLink')}
                        </button>
                        
                        <button 
                            type="button" 
                            className="back-btn"
                            onClick={onBack || onShowLogin}
                            disabled={isLoading}
                        >
                            {t('back')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;